import defaultSettings from '@/settings'
// import store from '@/store'

const title = defaultSettings.title
// const title = store.getters.title

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
